import { Schema } from 'effect';

/**
 * Taxon filter state schemas
 *
 * Internal state for the **taxon** filter dimension — used by the search filter
 * rail to narrow results to one or more catalogue taxons. Taxons are identified
 * by their string code (e.g. `rc-auta-hpi`) and stored in a HashSet.
 *
 * Mirrors the brand dimension ({@link BrandFilterStateSet}): a HashSet of a
 * branded string that maps to a comma-separated API param. For a category page
 * (where the taxon comes from the route, not a filter) this set is always empty,
 * so the dimension is a no-op there.
 *
 * @module TaxonFilterState
 */

/**
 * Branded type for taxon code strings, distinguishing them from arbitrary
 * strings at the type level.
 *
 * @example
 * const code = TaxonCode.make('rc-auta-hpi');
 */
export const TaxonCode = Schema.String.pipe(Schema.brand('TaxonCode'));

export type TaxonCode = Schema.Schema.Type<typeof TaxonCode>;

/**
 * HashSet of selected taxon codes — the current taxon filter state.
 */
export const TaxonFilterStateSet = Schema.HashSet(TaxonCode);

export type TaxonFilterStateSet = Schema.Schema.Type<typeof TaxonFilterStateSet>;
